//Angular
import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//App animations
import { AppAnimations } from 'src/app/_shared/animations';
//App Services
import { GridService, SkeletonLoaderService } from 'src/app/_core/services';
//App Data
import { PaymentSource, GridColumnsTransactions, OpacityState, TransactionStatus, TransactionKind, DateFormatValues } from 'src/app/app.data';
import { RestResponse } from 'src/app/_shared/models';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { SettingsService } from '../../_services/api/settings.service';

@Component({
  animations: [AppAnimations],
  selector: 'payment-operations-detail',
  templateUrl: './payment-operations-detail.component.html'
})

export class PaymentOperationsDetailComponent implements OnInit, OnDestroy {

  gridBulkSectionName: string = 'Transactions';
  gridBulkCollectionOfActions: Array<string> = ['export'];
  gridColumnsSection: string = 'transactions';
  gridName: string = 'Transaction';
  gridFilter: boolean = false;
  gridFiltersSection: string = 'transactions';
  gridPanelPreferences: boolean = false;
  gridSearchNotFoundImage: string = './assets/images/no-transactions-02.png';
  gridSearchNotFoundTitle: string = 'No transactions found';
  gridSearchNotFoundDescription: string = 'Keep calm and put the money on the bag';
  panelFiltersSectionId: string = 'transactions';
  panelFiltersGroupDisplayName: string = 'Transaction';
  paymentRunId: number;
  private subs = new Unsubscriber();

  @Input() _dateFormatValues = DateFormatValues;
  @Input() _gridCols = GridColumnsTransactions;
  @Input() _paymentSource = PaymentSource;
  @Input() _transactionStatus = TransactionStatus;
  @Input() _transactionKind = TransactionKind;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    public _grid: GridService,
    public _meta: MetaService,
    public _skeleton: SkeletonLoaderService,
    private settingsService: SettingsService,
  ) {
    this._iconRegistry.addSvgIcon('card-alipay', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-alipay.svg'));
    this._iconRegistry.addSvgIcon('card-amex', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-amex.svg'));
    this._iconRegistry.addSvgIcon('card-diners', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-diners.svg'));
    this._iconRegistry.addSvgIcon('card-discover', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-discover.svg'));
    this._iconRegistry.addSvgIcon('card-elo', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-elo.svg'));
    this._iconRegistry.addSvgIcon('card-hypercard', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-hypercard.svg'));
    this._iconRegistry.addSvgIcon('card-jcb', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-jcb.svg'));
    this._iconRegistry.addSvgIcon('card-maestro', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-maestro.svg'));
    this._iconRegistry.addSvgIcon('card-master', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-master.svg'));
    this._iconRegistry.addSvgIcon('card-paypal', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-paypal.svg'));
    this._iconRegistry.addSvgIcon('card-unionpay', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-unionpay.svg'));
    this._iconRegistry.addSvgIcon('card-verve', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-verve.svg'));
    this._iconRegistry.addSvgIcon('card-visa', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/card-visa.svg'));

    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-card', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-card-01.svg'))
    this._iconRegistry.addSvgIcon('ico-clear', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close-menu', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-03.svg'));
    this._iconRegistry.addSvgIcon('ico-delete', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-02.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-01.svg'));
    this._iconRegistry.addSvgIcon('ico-filter', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-filter-07.svg'));
    this._iconRegistry.addSvgIcon('ico-import', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-import-02.svg'));
    this._iconRegistry.addSvgIcon('ico-kind-checkout', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-checkout-01.svg'))
    this._iconRegistry.addSvgIcon('ico-kind-cron', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-cron-01.svg'))
    this._iconRegistry.addSvgIcon('ico-kind-desktop', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-desktop-01.svg'))
    this._iconRegistry.addSvgIcon('ico-kind-retry', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-retry-01.svg'))
    this._iconRegistry.addSvgIcon('ico-next', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-new-customer', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-01.svg'));
    this._iconRegistry.addSvgIcon('ico-search', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-search-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));

    this.subs.addSub = this._route.params.subscribe(params => {
      this.paymentRunId = params['id'];
    });
  }

  ngOnInit(): void { }

  ngOnDestroy() {
    this._grid.clearData();
    this._skeleton.skeletonGridLoader = false;
    this._skeleton.skeletonGridDataLoader = false;
    
    this.subs.unsubscribe();
  }

  getPaymentRuns() {
    this._grid.statusGrid = OpacityState.isHidden;
    this._grid.statusGridMessage = OpacityState.isHidden;

    const httpParams: HttpParamsInterface = {
      orderBy: this._grid.orderBy,
      sortBy: this._grid.sortBy,
      filterId: this._grid.selectedFilterId,
      pageNo: this._grid.currentPageNumber,
      itemPerPage: this._grid.itemsPerPage,
      query: this._grid.searchQuery
    }

    this.subs.addSub = this.settingsService.getPaymentRunByPaymentRunId(this.paymentRunId, httpParams, true).subscribe(
      (res: RestResponse) => {
        this._grid.currentPageNumber = res.currentPageNumber;
        this._grid.itemsPerPage = res.itemsPerPage;
        this._grid.totalItems = res.totalItems;
        this._grid.totalPages = res.totalPages;
        this._grid.collectionOfGridItems = <Array<any>>res.data;
        this._grid.sortedData = this._grid.collectionOfGridItems.slice();

        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;

        if (this._grid.collectionOfGridItems.length > 0) {
          this._grid.statusGrid = OpacityState.isVisible;
          this._grid.statusGridMessage = OpacityState.isHidden;
        } else {
          this._grid.statusGrid = OpacityState.isHidden;
          this._grid.statusGridMessage = OpacityState.isVisible;
        }
      },
      (err: RestResponse) => {
        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;
        this._meta.showNotification(err);
      }
    );
  }
}
